import * as React from 'react';

import AlertModalContainer from '../../components/alertModal/AlertModalContainer';
import PNRListContainer from './components/PNRList/PNRListContainer';
import './SearchResultPage.css';
import OverviewBreadcrumb from '../../components/overviewSearchBar/overviewBreadcrumb/OverviewBreadcrumb';
import MenuBar from '../../components/menuBar/MenuBar';
import PropTypes from 'prop-types';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import * as searchPNRService from  '../../services/searchPNR/SearchPNRService';
import ModalLoad from '../../components/modalLoad/ModalLoad';
import '../home/BackGroundImage.css';
import PNRListNoResultContainer from './components/PNRList/PNRListNoResultContainer';

const I18n = require('i18n-react').default;

const propTypes = {
  location: PropTypes.object
};

const defaultProps = {
  showLoading: false
};

class SearchResultPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isRedirect: false,
      pathname: '',
      customer: this.props.location.state.customer,
      pnrs: [],
      callbackTab:''
    };     
  }

  componentDidMount() {   
    this.search({
      cpf: this.state.customer.document.number
    });     
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal = () => {
    this.setState({
      openModal: false
    });
  };   

  search(searchPNRModel) {
    this.setState({
      showLoading: true
    });
    searchPNRService
      .search(searchPNRModel)
      .then(response => {
        if (response && response.error) throw response;
        if (response.status === 204) response.data = [];
        this.setState({
          pnrs: response.data,
          showLoading: false
        });
      })
      .catch(error => {
        this.setState({
          showLoading: false
        });
        this.showModal(I18n.translate('searchResult.msg.error'));
      });
  }

  renderModalLoading() {
		return (
			<ModalLoad
				id="modalLoad"
				showModal={this.state.showLoading}
				ref={c => {
					this.modalLoad = c;
				}}
			/>
		);
	}


  showModal(message) {
		this.setState({
			openModal: true,
			messageInfo: message
		});
	}

	closeModal = () => {
		this.setState({
			openModal: false
		});
	};

  callbackTab = (value) => {    
    this.setState({
			callbackTab: value
		}); 
  }

 renderSearchResult() {   
    return (
      <div>
        <MenuBar hideChangeSearch={true} callbackTab={this.callbackTab}/>
        <OverviewBreadcrumb
          id="componentOverviewBreadcrumb"
          steps={['features.breadcrumb.reservation']}
          actual="features.breadcrumb.reservation"
        />
        <div className="SearchResultPage bg-white padding-eight-bottom-56">
          <div className="section__outer">
            {this.state.showLoading ? (             
             this.renderModalLoading()
            ) : (
              this.renderResult()
            )}
          </div>
        </div>
        <AlertModalContainer
          title={I18n.translate('message.caution').toString()}
          message={I18n.translate('message.changeReservation').toString()}
          visible={false}
          closeModal={() => {}}
        />
        <AlertModalContainer
          title={I18n.translate('message.caution').toString()}
          message={I18n.translate('message.unexpectedServerError').toString()}
          visible={false}
          closeModal={() => {}}
        />
        <InfoModal
          id="modalError"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={this.closeModal}
          ref={c => {
            this.modalError = c;
          }}
        />
      </div>
    );
  }

  renderResult() {
    if (this.state.pnrs.length)
      return (
        <PNRListContainer searchResult={this.state.pnrs} azulNumber={this.state.customer.login} />
      );
    return <PNRListNoResultContainer />;
  }

  renderBackgroundLogo(){
    return (
      <div>
        <MenuBar hideChangeSearch={true} callbackTab={this.callbackTab}/>
        <div className='background-image'>
        </div>
        </div>
    )
  }

  render() {  
     var renderReturn;
     if(this.state.callbackTab !== "search")
        renderReturn = this.renderSearchResult()    
      else
        renderReturn = this.renderBackgroundLogo();
     return  renderReturn      
  }

}

SearchResultPage.propTypes = propTypes;
SearchResultPage.defaultProps = defaultProps;
export default SearchResultPage;



// WEBPACK FOOTER //
// ./src/page/searchResultPage/SearchResultPage.jsx